import { library } from '~fontawesome-core/fontawesome-svg-core'

import {
  faWrench,
  faFaceFrown,
  faTriangleExclamation,
  faClock,
  faCircle,
  faPersonDigging,
  faArrowTurnLeft,
  faAngleRight,
  faAngleLeft,
  faCirclePlus,
  faUsers,
  faCalendarDays,
  faCheckCircle,
  faTimesCircle,
  faLock,
  faPlus,
  faMinus,
  faSteeringWheel,
  faUserClock,
  faVideo,
  faCircleUser,
  faCircleStar,
  faStar,
} from '~fontawesome-core/pro-solid-svg-icons'
import {
  faEye,
  faCircleCheck,
  faCircleUserCircleQuestion
} from '~fontawesome-core/sharp-solid-svg-icons'
import {
  faCircleArrowDown
} from '~fontawesome-core/pro-duotone-svg-icons'
import {
  faQuoteRight
} from '~fontawesome-core/sharp-duotone-solid-svg-icons'

import { faCircleInfo } from '~fontawesome-core/pro-light-svg-icons'
library.add(
  faWrench,
  faFaceFrown,
  faTriangleExclamation,
  faCirclePlus,
  faClock,
  faPersonDigging,
  faArrowTurnLeft,
  faCircle,
  faPersonDigging,
  faAngleRight,
  faAngleLeft,
  faUsers,
  faCalendarDays,
  faCheckCircle,
  faTimesCircle,
  faLock,
  faPlus,
  faMinus,
  faCircleInfo,
  faSteeringWheel,
  faUserClock,
  faEye,
  faCircleCheck,
  faVideo,
  faCircleArrowDown,
  faCircleUser,
  faCircleStar,
  faCircleUserCircleQuestion,
  faStar,
  faQuoteRight
)

export default library
